import firebase from '../config/FirebaseConfig'

const db = firebase.firestore()

const getDynamicConstantValue = async (key) => {
  const snapshot = await db.collection('dynamic-constants').doc(key).get()
  if (!snapshot.exists) return null
  const data = snapshot.data()
  return data.value
}

export default {
  getDynamicConstantValue
}